import * as Sentry from '@sentry/nextjs';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { updateLocale } from '@/api/common';
import { setCookie } from '@/helpers/common';
import { LANGUAGE_PARAM } from '@/helpers/variables';

export function useLanguageChange() {
  const { i18n } = useTranslation();

  const [pending, setPending] = useState(false);

  const changeLng = useCallback(
    async (lng: string) => {
      setPending(true);

      try {
        setCookie(LANGUAGE_PARAM, lng);

        await i18n.changeLanguage(lng);
        await updateLocale({ locale: lng });

        Sentry.addBreadcrumb({
          category: 'localization',
          message: `Language changed to ${lng}`,
          level: 'info',
        });
      } catch (error) {
        Sentry.addBreadcrumb({
          category: 'localization',
          message: `Language change failed to ${lng}: ${error}`,
          level: 'error',
        });
      } finally {
        setPending(false);

        Sentry.addBreadcrumb({
          category: 'localization',
          message: `Language change finished`,
          level: 'info',
        });
      }
    },
    [i18n]
  );

  return [changeLng, pending] as [typeof changeLng, boolean];
}
